// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__1rsGK","tagName":"styles_tagName__DMEcn","crossIcon":"styles_crossIcon__18lB-"};